import React from "react";
import PropTypes from "prop-types";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
}));

const SelectReferenceDate = ({
  wantedReferenceDate,
  handleWantedReferenceDateChange,
  listOfValidReferenceDates,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box mt={1} mb={1}>
      <FormControl className={classes.formControl}>
        <InputLabel id="select-reference-date-label">{t("climateAnalytics.selectReferenceDate")}</InputLabel>
        <Select
          labelId="select-reference-date-label"
          id="select-reference-date"
          value={wantedReferenceDate}
          onChange={handleWantedReferenceDateChange}
        >
          {listOfValidReferenceDates.map((validReferenceDate) => (
            <MenuItem value={validReferenceDate} key={validReferenceDate}>
              {validReferenceDate}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

SelectReferenceDate.propTypes = {
  wantedReferenceDate: PropTypes.string.isRequired,
  handleWantedReferenceDateChange: PropTypes.func.isRequired,
  listOfValidReferenceDates: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SelectReferenceDate;
